export const REMINDER_VALUES = {
    NONE: 'none',
    WHEN_DUE: '0',
    TEN_MINUTES_BEFORE: '-10',
    ONE_HOUR_BEFORE: '-60',
    NINE_AM_DAY_OF: '9am',
    NINE_AM_DAY_BEFORE: '9am_-1_day',
};
